import React from "react";
import { Shield } from "lucide-react";

// Phase 12.1 — High-Risk badge using semantic --danger tokens.
// AA-compliant in both light and dark mode.
export function HighRiskBadge({ className = "" }) {
  return (
    <span
      data-testid="high-risk-badge"
      className={`inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.10em] ${className}`}
      style={{
        backgroundColor: "var(--danger-bg)",
        color: "var(--danger-fg)",
        borderColor: "var(--danger-border)",
      }}
    >
      <Shield className="h-3 w-3" strokeWidth={2} />
      High risk
    </span>
  );
}

export default HighRiskBadge;
